export default {
    items: {
        data: []
    },

    clients: {data: []},

}